/* eslint-disable react-hooks/exhaustive-deps */
import { CustomModal } from "./Modal";
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useGame } from "../contexts";
import { BoxContainer } from "./Common";

export const DoodadBox = ({ pay }) => {
  const { turnData, currentPlayer, yourTurn, room, drawCard } = useGame();
  const [doodad, setDoodad] = useState(null);
  const [hasDoodad, setHasDoodad] = useState(null);
  const [disabled, setDisabled] = useState(false)

  const onPayClick = (val)=>{
    //setDisabled(true)
    pay(val)
  }

  useEffect(() => {
    const getDoodad = async (attempts = 0) => {
      const skipChild = currentPlayer.children === 0;
      const tempDoodad = await drawCard("doodad", (card) => {
        if (!card) return {};
        if (attempts < 20 && skipChild && card.child) return {};
        return { doodad: card };
      });
      if (!tempDoodad) return;
      if (attempts < 20 && skipChild && tempDoodad.child) {
        getDoodad(attempts + 1);
      } else {
        setDoodad(tempDoodad);
        if (
          tempDoodad.onlyOne &&
          currentPlayer.liabilities.some((x) => x.key === tempDoodad.key)
        ) {
          setHasDoodad("You already have one!");
        } else {
          setHasDoodad("");
        }
      }
    };
    if (turnData?.data) {
      setDoodad({ ...turnData.data });
    } else if (yourTurn) {
      if (!room?.doodad?.name) {
        getDoodad();
      }
    } else {
      setDoodad(room?.doodad || {});
    }
  }, [currentPlayer, turnData, room, yourTurn]);
 
  return (
    <CustomModal>
      <BoxContainer>
        <div>
          <h2>{doodad?.name}</h2>
          <p>{doodad?.hasDoodad || doodad?.text?.replace(/\\n \\n/g, '')}</p>
        </div>
        {yourTurn && (
          <div>
            {!hasDoodad ? (
              <Button type="primary" block  disabled={disabled} onClick={() => onPayClick(doodad)}>
                Pay
              </Button>
            ) : (
              <Button type="primary" block disabled={disabled} onClick={() => onPayClick(null)}>
                Done
              </Button>
            )}
          </div>
        )}
      </BoxContainer>
    </CustomModal>
  );
};

export const FastTrackDoodadBox = ({ pay }) => {
  const { yourTurn, room, currentPlayer } = useGame();
  const [doodad, setDoodad] = useState(null);
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {    
    const taxAuditCost = Math.floor(currentPlayer?.cash / 2)    
    //setDoodad(room?.ftBox);   
    setDoodad({...room?.ftBox, cost: taxAuditCost});
    
  }, [room]);

  const onPayClick = (val)=>{
    setDisabled(true)
    pay(val)
  }

  
  return (
    <CustomModal>
      <BoxContainer>
        <div>
          <h2>{doodad?.text}</h2>
          <p>{doodad?.description}</p>
        </div>
        {yourTurn && (
          <div>
            <Button type="primary" block  disabled={disabled} onClick={() => onPayClick(doodad)}>
              Pay
            </Button>
          </div>
        )}
      </BoxContainer>
    </CustomModal>
  );
};
